<section class="qa-nc-tab">
  <h2>{{ 'QA_LOG.NC' | translate }}</h2>
</section>
